export default __webpack_public_path__ + "static/media/vendor-spiker4.f67b72bc.jpg";